webpackJsonp([263791100135453],{

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    width: 100vw;\n    position: absolute;\n    left: 0;\n    z-index: 100;\n  "], ["\n    width: 100vw;\n    position: absolute;\n    left: 0;\n    z-index: 100;\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    width: 80%;\n    height: 1.6vw;\n    background-color: ", ";\n    display: inline-block;\n    transform: translate(-50%, -50%) skew(45deg);\n    left: 50%;\n    position: absolute;\n    z-index: 1;\n  "], ["\n    width: 80%;\n    height: 1.6vw;\n    background-color: ", ";\n    display: inline-block;\n    transform: translate(-50%, -50%) skew(45deg);\n    left: 50%;\n    position: absolute;\n    z-index: 1;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    border: 1.1vw solid ", ";\n    border-top-color: transparent;\n    border-left-color: transparent;\n    display: inline-block;\n    transform-origin: 50% 0%;\n    transform: translateX(-50%) rotate(45deg);\n    left: 50%;\n    position: absolute;\n    z-index: 1;\n  "], ["\n    border: 1.1vw solid ", ";\n    border-top-color: transparent;\n    border-left-color: transparent;\n    display: inline-block;\n    transform-origin: 50% 0%;\n    transform: translateX(-50%) rotate(45deg);\n    left: 50%;\n    position: absolute;\n    z-index: 1;\n  "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Divider = function Divider(_ref) {
	  var color = _ref.color,
	      className = _ref.className;
	
	  var Wrap = _styledComponents2.default.div(_templateObject);
	
	  var Div = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.colors[color];
	  });
	  var Diamond = _styledComponents2.default.div(_templateObject3, function (props) {
	    return props.theme.colors[color];
	  });
	
	  return _react2.default.createElement(
	    Wrap,
	    { className: className },
	    _react2.default.createElement(Div, null),
	    _react2.default.createElement(Diamond, null)
	  );
	};
	
	exports.default = Divider;
	module.exports = exports["default"];

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.HeaderBG = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(13);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _cloud_texture = __webpack_require__(69);
	
	var _cloud_texture2 = _interopRequireDefault(_cloud_texture);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HalfScreenParallaxHero = function HalfScreenParallaxHero(_ref) {
	  var title = _ref.title,
	      bg = _ref.bg,
	      symbol = _ref.symbol;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "section",
	      {
	        className: "page-title parallax13 parallax-fix page-title-large",
	        style: {
	          background: "url(" + bg + ") 50% 0px",
	          height: "50vh"
	        }
	      },
	      _react2.default.createElement(
	        "div",
	        { className: "titleContainer" },
	        _react2.default.createElement(
	          "div",
	          { className: "animated fadeInUp" },
	          _react2.default.createElement("div", { className: "separator-line bg-yellow no-margin-top margin-five" }),
	          _react2.default.createElement(
	            "h1",
	            { className: "white-text" },
	            title
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "no-margin-top content-section" },
	      _react2.default.createElement(
	        "div",
	        { className: "extra-texture" },
	        _react2.default.createElement("img", { src: _cloud_texture2.default, style: { width: "100%" } }),
	        _react2.default.createElement("img", { className: "symbol", src: symbol })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "text-center heading no-padding overflow-hidden" },
	      _react2.default.createElement(
	        "h1",
	        { className: "white-text" },
	        title
	      )
	    )
	  );
	};
	
	exports.default = HalfScreenParallaxHero;
	var HeaderBG = exports.HeaderBG = "** extracted graphql fragment **";

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _orange_symbol = __webpack_require__(48);
	
	var _orange_symbol2 = _interopRequireDefault(_orange_symbol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeadingDescription = function HeadingDescription(_ref) {
	  var heading = _ref.heading,
	      description = _ref.description;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "headingDescription" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-sm-5 headingDescription-title" },
	      _react2.default.createElement(
	        "h2",
	        null,
	        _react2.default.createElement("img", { src: _orange_symbol2.default, className: "headingDescription-titleSymbol", alt: true }),
	        heading
	      )
	    ),
	    _react2.default.createElement("div", { className: "col-sm-7 headingDescription-description", dangerouslySetInnerHTML: { __html: description } })
	  );
	};
	
	exports.default = HeadingDescription;
	module.exports = exports["default"];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(13);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KeyPerson = function KeyPerson(_ref) {
	  var img = _ref.img,
	      name = _ref.name,
	      description = _ref.description;
	
	
	  return _react2.default.createElement(
	    "div",
	    {
	      className: "col-md-3 col-sm-3 text-center wow fadeIn features-2",
	      "data-wow-duration": "300ms"
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "key-person" },
	      _react2.default.createElement(
	        "div",
	        { className: "key-person-img" },
	        _react2.default.createElement("img", { src: img.resolutions.src })
	      ),
	      _react2.default.createElement(
	        "h5",
	        null,
	        name
	      ),
	      _react2.default.createElement("div", { className: "separator-line bg-yellow" }),
	      _react2.default.createElement("p", {
	        dangerouslySetInnerHTML: {
	          __html: description
	        }
	      })
	    )
	  );
	};
	
	exports.default = KeyPerson;
	module.exports = exports["default"];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n      font-size: 6vw;\n      font-family: \"Proxima Nova Condensced\", sans-serif;\n      font-weight: normal;\n      position: relative;\n      line-height: 1;\n      display: inline-block;\n      vertical-align: middle;\n      margin-left: -1vw;\n      margin-bottom: 1vw;\n      color: ", ";\n\n      @media screen and (min-width: 1920px) {\n        font-size: 110px;\n      }\n\n      @media (max-width: 992px) {\n        font-size: 6.8vw;\n      }\n\n      @media (max-width: 767px) {\n        font-size: 8vw;\n      }\n    "], ["\n      font-size: 6vw;\n      font-family: \"Proxima Nova Condensced\", sans-serif;\n      font-weight: normal;\n      position: relative;\n      line-height: 1;\n      display: inline-block;\n      vertical-align: middle;\n      margin-left: -1vw;\n      margin-bottom: 1vw;\n      color: ", ";\n\n      @media screen and (min-width: 1920px) {\n        font-size: 110px;\n      }\n\n      @media (max-width: 992px) {\n        font-size: 6.8vw;\n      }\n\n      @media (max-width: 767px) {\n        font-size: 8vw;\n      }\n    "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      font-size: 39px;\n      font-family: \"Proxima Nova Condensced\", sans-serif;\n      margin-left: -1vw;\n      color: ", ";\n\n      @media (max-width: 992px) {\n        font-size: 3.2vw;\n      }\n      @media (max-width: 767px) {\n        font-size: 4.5vw;\n      }\n    "], ["\n      font-size: 39px;\n      font-family: \"Proxima Nova Condensced\", sans-serif;\n      margin-left: -1vw;\n      color: ", ";\n\n      @media (max-width: 992px) {\n        font-size: 3.2vw;\n      }\n      @media (max-width: 767px) {\n        font-size: 4.5vw;\n      }\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n      max-width: 1.8em;\n      margin-top: -0.3em;\n    "], ["\n      max-width: 1.8em;\n      margin-top: -0.3em;\n    "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrimaryHeading = function (_Component) {
	  _inherits(PrimaryHeading, _Component);
	
	  function PrimaryHeading() {
	    _classCallCheck(this, PrimaryHeading);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PrimaryHeading.prototype.render = function render() {
	    var Heading = _styledComponents2.default.h1(_templateObject, function (props) {
	      return props.theme.colors[color];
	    });
	
	    var Subheading = _styledComponents2.default.h2(_templateObject2, function (props) {
	      return props.theme.colors[color];
	    });
	
	    var Img = _styledComponents2.default.img(_templateObject3);
	    var _props = this.props,
	        heading = _props.heading,
	        subheading = _props.subheading,
	        img = _props.img,
	        color = _props.color;
	
	    return _react2.default.createElement(
	      "div",
	      { className: this.props.className },
	      _react2.default.createElement(
	        Heading,
	        null,
	        _react2.default.createElement(Img, { src: img }),
	        heading
	      ),
	      _react2.default.createElement(
	        Subheading,
	        null,
	        subheading
	      )
	    );
	  };
	
	  return PrimaryHeading;
	}(_react.Component);
	
	exports.default = PrimaryHeading;
	module.exports = exports["default"];

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    background-image: url(\"", "\");\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    position: relative;\n    width: 100%;\n    background-position: center top;\n    background-size: cover;\n    text-align: center;\n    transition-duration: 0s;\n    padding-top: ", "%;\n    box-shadow: inset 0 10px 2px -4px rgba(0, 0, 0, 0.4);\n\n    /* @media (max-width: 1029px) {\n      background-position: inherit;\n      background-position: center bottom;\n    } */\n    @media (max-width: 768px) {\n      background-size: 200%;\n      /* background-position: center -390px; */\n      /* padding-top: 70%; */\n    }\n  "], ["\n    background-image: url(\"", "\");\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    position: relative;\n    width: 100%;\n    background-position: center top;\n    background-size: cover;\n    text-align: center;\n    transition-duration: 0s;\n    padding-top: ", "%;\n    box-shadow: inset 0 10px 2px -4px rgba(0, 0, 0, 0.4);\n\n    /* @media (max-width: 1029px) {\n      background-position: inherit;\n      background-position: center bottom;\n    } */\n    @media (max-width: 768px) {\n      background-size: 200%;\n      /* background-position: center -390px; */\n      /* padding-top: 70%; */\n    }\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    bottom: 0;\n    margin-bottom: 6vw;\n\n    @media (max-width: 768px) {\n      position: relative;\n      bottom: 40px;\n      margin-bottom: unset !important;\n    }\n  "], ["\n    position: absolute;\n    bottom: 0;\n    margin-bottom: 6vw;\n\n    @media (max-width: 768px) {\n      position: relative;\n      bottom: 40px;\n      margin-bottom: unset !important;\n    }\n  "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _NextPageSection = __webpack_require__(71);
	
	var _NextPageSection2 = _interopRequireDefault(_NextPageSection);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SplitImageBottom = function SplitImageBottom(_ref) {
	  var img = _ref.img,
	      blurb = _ref.blurb,
	      link = _ref.link,
	      linkText = _ref.linkText;
	
	  var Main = _styledComponents2.default.div(_templateObject, img.resolutions.src, img.resolutions.height / 1920 * 100 - 0.1);
	
	  var Next = (0, _styledComponents2.default)(_NextPageSection2.default)(_templateObject2);
	  return _react2.default.createElement(
	    Main,
	    { className: "container" },
	    _react2.default.createElement(Next, { blurb: blurb, to: link, linkText: linkText })
	  );
	};
	
	exports.default = SplitImageBottom;
	module.exports = exports["default"];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.splitImg = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    padding-top: ", "%;\n    width: 100%;\n    background-image: url(\"", "\");\n    position: relative;\n    max-width: 100%;\n    background-position: center top;\n    background-size: cover;\n    text-align: center;\n    box-shadow: inset 0 10px 2px -4px rgba(0, 0, 0, 0.4);\n\n    @media (max-width: 1029px) {\n      background-position: inherit;\n      background-position: center bottom;\n    }\n    @media (max-width: 768px) {\n      background-size: 230%;\n      padding-top: 64%;\n    }\n  "], ["\n    padding-top: ", "%;\n    width: 100%;\n    background-image: url(\"", "\");\n    position: relative;\n    max-width: 100%;\n    background-position: center top;\n    background-size: cover;\n    text-align: center;\n    box-shadow: inset 0 10px 2px -4px rgba(0, 0, 0, 0.4);\n\n    @media (max-width: 1029px) {\n      background-position: inherit;\n      background-position: center bottom;\n    }\n    @media (max-width: 768px) {\n      background-size: 230%;\n      padding-top: 64%;\n    }\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding-top: 8vw;\n\n    @media (max-width: 768px) {\n      padding-top: 10vw;\n    }\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding-top: 8vw;\n\n    @media (max-width: 768px) {\n      padding-top: 10vw;\n    }\n  "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _PrimaryHeading = __webpack_require__(72);
	
	var _PrimaryHeading2 = _interopRequireDefault(_PrimaryHeading);
	
	var _Divider = __webpack_require__(27);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SplitImageTop = function SplitImageTop(_ref) {
	  var img = _ref.img,
	      heading = _ref.heading,
	      subheading = _ref.subheading,
	      numberLabel = _ref.numberLabel;
	
	  //Padding is calculated based on bg aspect ratio. Subtracts a bit to account for rounding
	
	  var Main = _styledComponents2.default.div(_templateObject, Math.ceil(img.resolutions.height / 1920 * 100), img.resolutions.src);
	
	  var Heading = (0, _styledComponents2.default)(_PrimaryHeading2.default)(_templateObject2);
	
	  return _react2.default.createElement(
	    Main,
	    null,
	    _react2.default.createElement(Heading, {
	      heading: heading,
	      subheading: subheading,
	      img: numberLabel,
	      color: "white"
	    })
	  );
	};
	
	var splitImg = exports.splitImg = "** extracted graphql fragment **";
	
	exports.default = SplitImageTop;

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(13);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _KeyPerson = __webpack_require__(50);
	
	var _KeyPerson2 = _interopRequireDefault(_KeyPerson);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThreeFeaturesRow = function ThreeFeaturesRow(_ref) {
	  var features = _ref.features,
	      skillOrStrength = _ref.skillOrStrength;
	
	  var featureImage = skillOrStrength === "skill" ? "skill_image" : "strength_image";
	  var featureName = skillOrStrength === "skill" ? "skill_name" : "strength_name";
	  var featureDesc = skillOrStrength === "skill" ? "skill_desc" : "strength_description";
	
	  return _react2.default.createElement(
	    "div",
	    { className: "offers threeStrengths text-center position-relative" },
	    _react2.default.createElement(
	      "div",
	      { className: "row" },
	      features.map(function (feature, i) {
	        return _react2.default.createElement(
	          "div",
	          {
	            key: i,
	            className: "col-md-4 col-sm-4 text-center wow fadeIn features-2",
	            "data-wow-duration": "300ms"
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "key-person" },
	            _react2.default.createElement(
	              "div",
	              { className: "key-person-img" },
	              _react2.default.createElement("img", {
	                src: feature[featureImage].localFile.childImageSharp.resolutions.src,
	                style: { transition: 'all .3s ease' }
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "key-person-details-wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: "key-person-details no-border" },
	                _react2.default.createElement(
	                  "h5",
	                  null,
	                  feature[featureName]
	                ),
	                _react2.default.createElement("div", { className: "separator-line bg-black" }),
	                _react2.default.createElement(
	                  "p",
	                  null,
	                  feature[featureDesc]
	                )
	              )
	            ),
	            _react2.default.createElement("div", { className: "fadeOutGrad" })
	          )
	        )
	        // <KeyPerson
	        //   key={i}
	        //   img={a[featureImage].localFile.childImageSharp}
	        //   name={a[featureName]}
	        //   description={a[featureDesc]}
	        // />
	        ;
	      })
	    )
	  );
	};
	
	exports.default = ThreeFeaturesRow;
	module.exports = exports["default"];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.trailingIcon = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    margin: 0 0 50px;\n    max-width: 80%;\n    padding-top: ", "\n  "], ["\n    margin: 0 0 50px;\n    max-width: 80%;\n    padding-top: ", "\n  "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyImage = __webpack_require__(13);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TrailingIcon = function TrailingIcon(_ref) {
	  var img = _ref.img,
	      bigTopPadding = _ref.bigTopPadding;
	
	  var Icon = _styledComponents2.default.img(_templateObject, bigTopPadding ? '70px' : null);
	  return _react2.default.createElement(Icon, {
	    src: img.resolutions.src || img,
	    alt: "Icon for the end of the section"
	  });
	};
	
	var trailingIcon = exports.trailingIcon = "** extracted graphql fragment **";
	
	exports.default = TrailingIcon;

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/label-numbers-about01.b825d117.png";

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/label-numbers-about02.19b2876e.png";

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/label-numbers-about03.f2232a71.png";

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cloud_texture.01af96b4.png";

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(13);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _HalfScreenParallaxHero = __webpack_require__(49);
	
	var _HalfScreenParallaxHero2 = _interopRequireDefault(_HalfScreenParallaxHero);
	
	var _HeadingDescription = __webpack_require__(102);
	
	var _HeadingDescription2 = _interopRequireDefault(_HeadingDescription);
	
	var _ThreeFeaturesRow = __webpack_require__(105);
	
	var _ThreeFeaturesRow2 = _interopRequireDefault(_ThreeFeaturesRow);
	
	var _TrailingIcon = __webpack_require__(53);
	
	var _TrailingIcon2 = _interopRequireDefault(_TrailingIcon);
	
	var _SplitImageTop = __webpack_require__(104);
	
	var _SplitImageTop2 = _interopRequireDefault(_SplitImageTop);
	
	var _SplitImageBottom = __webpack_require__(103);
	
	var _SplitImageBottom2 = _interopRequireDefault(_SplitImageBottom);
	
	var _KeyPerson = __webpack_require__(50);
	
	var _KeyPerson2 = _interopRequireDefault(_KeyPerson);
	
	var _Divider = __webpack_require__(27);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _ParallaxDivider = __webpack_require__(51);
	
	var _ParallaxDivider2 = _interopRequireDefault(_ParallaxDivider);
	
	var _labelNumbersAbout = __webpack_require__(540);
	
	var _labelNumbersAbout2 = _interopRequireDefault(_labelNumbersAbout);
	
	var _labelNumbersAbout3 = __webpack_require__(541);
	
	var _labelNumbersAbout4 = _interopRequireDefault(_labelNumbersAbout3);
	
	var _labelNumbersAbout5 = __webpack_require__(542);
	
	var _labelNumbersAbout6 = _interopRequireDefault(_labelNumbersAbout5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var aboutPage = function (_React$Component) {
	  _inherits(aboutPage, _React$Component);
	
	  function aboutPage() {
	    _classCallCheck(this, aboutPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  aboutPage.prototype.render = function render() {
	    var dataql = this.props.data;
	    var acf = this.props.data.wordpressPage.acf;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "wow fadeIn" },
	      _react2.default.createElement(_reactHelmet2.default, { title: "About | Moon Beyond Co" }),
	      _react2.default.createElement(_HalfScreenParallaxHero2.default, {
	        title: this.props.data.wordpressPage.title,
	        bg: dataql.headerBG.resolutions.src,
	        symbol: acf.symbol.localFile.childImageSharp.sizes.src
	      }),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "dividerHolder" },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement(
	              "div",
	              { className: "row aboutHeadingSection" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-sm-12 text-center heading" },
	                _react2.default.createElement(
	                  "h2",
	                  { className: "headingSubtitle" },
	                  "Moon Beyond Creative"
	                ),
	                _react2.default.createElement(_HeadingDescription2.default, {
	                  heading: "Embarking With Us",
	                  description: acf.crew_description
	                })
	              )
	            ),
	            _react2.default.createElement(_ThreeFeaturesRow2.default, {
	              features: acf.three_strengths,
	              skillOrStrength: "strength"
	            }),
	            _react2.default.createElement(_Divider2.default, { color: "orange" })
	          )
	        ),
	        _react2.default.createElement(_SplitImageTop2.default, {
	          img: dataql.splitImgTop,
	          heading: acf.crew_heading,
	          subheading: acf.crew_subheading,
	          numberLabel: dataql.numberLabel1.sizes.src
	        }),
	        _react2.default.createElement(
	          "section",
	          { className: "crewSection sectionLargeHeading" },
	          _react2.default.createElement(
	            "div",
	            { className: "container text-center" },
	            _react2.default.createElement(
	              "div",
	              { className: "row offers text-center" },
	              acf.crew.map(function (a, i) {
	                return _react2.default.createElement(_KeyPerson2.default, {
	                  key: i,
	                  img: a.member_image.localFile.childImageSharp,
	                  name: a.member_name,
	                  description: a.member_description
	                });
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row crewDescription" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-12" },
	                _react2.default.createElement("p", {
	                  dangerouslySetInnerHTML: { __html: acf.crew_description }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row tabContainer" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-7 col-sm-12 center-col" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "tab-style1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: true },
	                    _react2.default.createElement(
	                      "ul",
	                      { className: "nav nav-tabs nav-tabs-light text-left" },
	                      acf.mission_statement_tab_section.map(function (a, i) {
	                        return _react2.default.createElement(
	                          "li",
	                          { className: i === 0 ? "active" : null, key: i },
	                          _react2.default.createElement(
	                            "a",
	                            { href: "#tab_sec" + (i + 1), "data-toggle": "tab" },
	                            a.tab_name
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "tab-content" },
	                    acf.mission_statement_tab_section.map(function (a, i) {
	                      return _react2.default.createElement(
	                        "div",
	                        {
	                          key: i,
	                          className: "tab-pane med-text fade in " + (i === 0 ? "active" : ""),
	                          id: "tab_sec" + (i + 1)
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "text-left" },
	                          _react2.default.createElement("div", {
	                            className: "twoColumns",
	                            dangerouslySetInnerHTML: {
	                              __html: a.left_column
	                            }
	                          })
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_ParallaxDivider2.default, {
	          tagline: acf.parallax_section_text,
	          taglineColor: "#fff",
	          bg: acf.parallax_section_image.localFile.childImageSharp.sizes.src,
	          trailingElementColor: "black"
	        }),
	        _react2.default.createElement(_Divider2.default, { color: "black" }),
	        _react2.default.createElement(
	          "div",
	          { className: "clientsSection sectionLargeHeading" },
	          _react2.default.createElement(
	            "div",
	            { className: "container text-center" },
	            _react2.default.createElement(
	              "div",
	              { className: "row headingSection" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 headingLargeElement" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  _react2.default.createElement("img", { src: dataql.numberLabel3.sizes.src }),
	                  acf.meet_the_clients_heading
	                ),
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  acf.meet_the_clients_subheading
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "row offers text-center",
	                style: { marginBottom: 150 }
	              },
	              acf.meet_the_clients_columns.map(function (a, i) {
	                return _react2.default.createElement(
	                  "div",
	                  {
	                    key: i,
	                    className: "col-sm-4 text-center wow fadeIn features-2",
	                    "data-wow-duration": "300ms"
	                  },
	                  _react2.default.createElement("p", {
	                    dangerouslySetInnerHTML: {
	                      __html: a.column_text
	                    }
	                  })
	                );
	              })
	            ),
	            _react2.default.createElement(_TrailingIcon2.default, { img: dataql.trailingIcon })
	          )
	        ),
	        _react2.default.createElement(_SplitImageBottom2.default, {
	          img: dataql.splitImgBottom,
	          blurb: acf.next_page_blurb,
	          link: "../Services",
	          linkText: acf.next_page_button_text
	        })
	      )
	    );
	  };
	
	  return aboutPage;
	}(_react2.default.Component);
	
	exports.default = aboutPage;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-39c1ae090f6b257dfed2.js